export default __webpack_public_path__ + "static/media/assignment-white.d5cf1956.svg";